import { observable } from "mobx";
import { debounce, isEqual } from "lodash";

export type SearchStoreOptions<FILTER extends {}> = {
  initialFilter: FILTER;
};

export type FetchCallback = (skip?: number, limit?: number) => Promise<any>;

export class FilterManager<FILTER extends {}> {
  protected _initialFilter: FILTER;
  @observable protected _filter: FILTER;
  private debouncedFetch = debounce(this.fetch, 400);

  constructor(private options: SearchStoreOptions<FILTER>, private fetch: FetchCallback) {
    this.clearFilter = this.clearFilter.bind(this);

    this._filter = { ...options.initialFilter };
    this._initialFilter = { ...options.initialFilter };
  }

  get filter() {
    return this._filter;
  }

  clearFilter() {
    this._filter = { ...this._initialFilter };
    this.fetch();
  }

  updateFilter(value: Partial<FILTER>, debounced = false) {
    this._filter = {
      ...this._filter,
      ...value
    };

    debounced ? this.debouncedFetch() : this.fetch();
  }

  isFilterDirty(key: keyof FILTER) {
    if (Array.isArray(this._initialFilter[key])) {
      return !isEqual(this._initialFilter[key], this.filter[key]);
    }

    return this._initialFilter[key] !== this.filter[key];
  }
}
